import { Injectable } from "@angular/core";
import { type Resolve, Router } from '@angular/router';
import { AuthControlFacade, NodeSharedFacade } from '@medsurf/flat-facades';
import { AuthControlService } from "@medsurf/flat-services";
import { catchError, filter, firstValueFrom, of } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class NodesByRouteSharedResolver implements Resolve<void> {
  constructor(
    protected nodeSharedFacade: NodeSharedFacade, 
    protected router: Router,
    protected authContorlService: AuthControlService,
    protected authControlFacade: AuthControlFacade
  ) { }

  resolve() {
    return this.nodeSharedFacade.requestNodesByCurrentRoute().pipe(catchError(async (result) => {
      if (this.authControlFacade.snapshot_isAuthenticated() === false) {
        this.authContorlService.setRedirectUrl(window.location.href);
        this.router.navigate(['/login']);
        return of(result);
      }
      
      const isAuthenticated = await firstValueFrom(this.authControlFacade.isAuthenticated$.pipe(filter(a => a !== null)));
      if (isAuthenticated === false) {
        this.authContorlService.setRedirectUrl(window.location.href);
        this.router.navigate(['/login']);
        return of(result);
      }

      this.router.navigate(['/']);
      return of(result);
    }))
  }
}